<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false"
          :show-top-header="true" buy-button-class="btn-default btn-small">

    <!-- Start Slider Area -->
    <div class="slider-area slider-style-6 shape-left inheader-not-transparent height-750">
      <div class="shape-image w-auto">
        <img src="../../assets/images/banner/white-shape.svg" alt="Banner Images"/>
      </div>
      <div class="container">
        <VueSlickCarousel v-bind="sliderSetting" v-if="sliderData.length!==0">
          <div v-for="(item,index) in sliderData " :key="index">
            <div class="row row--30 align-items-center">
              <div class="order-2 order-lg-1 col-lg-5 mt_md--50 mt_sm--50 mt_lg--30">
                <div class="inner text-start">
                  <SectionSubTitle v-if="item.content5"
                      :subtitle="item.content5"
                      data-aos="fade-up"
                      data-aos-delay="60"
                  />
                  <h1 class="title color-heading " data-aos="fade-up" data-aos-delay="100">
                    {{ item.title }}
                  </h1>
                  <ul class="list-icon" data-aos="fade-up" data-aos-delay="200">
                    <li v-if="item.content1" style="color:#c9cdd4!important;">
                      <IconHome  name="check" size="10" icon-class="icon d-inline-flex align-items-center justify-content-center" />
                      <span >{{item.content1}}</span>
                    </li>
                    <li v-if="item.content2">
                      <IconHome name="check" size="10" icon-class="icon d-inline-flex align-items-center justify-content-center"/>
                      <span >{{item.content2}}</span>
                    </li>
                    <li v-if="item.content3">
                      <IconHome name="check" size="10" icon-class="icon d-inline-flex align-items-center justify-content-center"/>
                      <span >{{item.content3}}</span>
                    </li>
                  </ul>
                  <div class="button-group mt--30 mt_sm--20" data-aos="fade-up" data-aos-delay="200">
                    <a class="btn-default btn-primary round btn-icon" v-if="item.redirectUrl"
                       :href="item.redirectUrl" target="_blank">
                      前往挑选
                      <Icon name="arrow-right" size="20" icon-class="icon"/>
                    </a>

                    <router-link class="btn-default btn-primary btn-border round btn-icon" to="/contact-us">
                      联系我们
                      <Icon name="arrow-right" size="20" icon-class="icon"/>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-lg-7 order-1 order-lg-2">
                <div class="frame-image" data-aos="fade-up" data-aos-delay="100">
                  <img :src="item.image" alt="Banner Images"/>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>

      </div>
    </div>
    <!-- End Slider Area -->




    <HomeNews :news-list="newsList"/>

  </Layout>
</template>

<script>


import Layout from '../../components/common/Layout'
import SectionSubTitle from '../../components/elements/sectionTitle/SectionSubTitle'
import Separator from '../../components/elements/separator/Separator'
import VueSlickCarousel from 'vue-slick-carousel'

import Testimonial from '../../components/elements/testimonial/Testimonial'
import Portfolio from '../../components/elements/portfolio/Portfolio'
import ServiceFive from '../../components/elements/service/ServiceFive'
import Progressbar from '../../components/elements/progressbar/Progressbar'
import AboutEight from "../../components/elements/about/AboutEight";
import HomeNews from "../home-site/HomeNews"
import IconHome from "../../components/icon/IconHome";
import Icon from "../../components/icon/Icon";
export default {
  name: 'HomeFull',
  components: {
    Icon,
    HomeNews,
    AboutEight,
    IconHome,
    Progressbar,
    ServiceFive,
    Portfolio,
    Testimonial,
    Separator,
    SectionSubTitle,
    Layout,
    VueSlickCarousel
  },

  data() {
    return {
      sliderSetting: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        //speed: 5000,
        autoplaySpeed: 5000,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      },
      sliderData: [],
      newsList: [],

    }
  },
  created() {
    this.getPic();
  },
  methods: {
    async getPic() {

      await this.postRequest('/system/web/listHome').then(resp => {

        if (resp.data) {
          let assertList = [];
          resp.data.pics.forEach(item => {
            var fileUrl = item.url;
            fileUrl = process.env.VUE_APP_BASE_API + fileUrl;
            var picData = {
              image: fileUrl,
              title: item.title,
              content1: item.content1,
              content2: item.content2,
              content3: item.content3,
              content4: item.content4,
              content5: item.content5,
              redirectUrl: item.redirectUrl
            }
            assertList.push(picData);

          })
          let newsData = resp.data.news;
          newsData.forEach(item => {
            if (item.thumbUrl) {
              var fileUrl = item.thumbUrl;
              fileUrl = process.env.VUE_APP_BASE_API + fileUrl;
              item.thumbUrl = fileUrl;
            } else {
              item.thumbUrl = "";
            }
          })
          this.sliderData = assertList;
          this.newsList = newsData;

        }
      })
    },

    getBase64(imgUrl) {
      return new Promise((resolve, reject) => {
        if (!imgUrl) {
          reject('请传入imgUrl内容')
        }
        if (/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(imgUrl)) {
          window.URL = window.URL || window.webkitURL
          var xhr = new XMLHttpRequest()
          xhr.open('get', imgUrl, true)
          xhr.responseType = 'blob'
          xhr.onload = function () {
            if (this.status == 200) {
              // 得到一个blob对象
              var blob = this.response
              const oFileReader = new FileReader()
              oFileReader.onloadend = function (e) {
                const base64 = e.target.result
                resolve(base64 || '')
              }
              oFileReader.readAsDataURL(blob);
            }
          }
          xhr.send()
        } else {
          // 非图片地址
          reject('非(png/jpe?g/gif/svg等)图片地址')
        }
      })
    },
  }
}
</script>

<style scoped>
.slider-img {
  width: 100%;
  height: 100%;
}
body.active-light-mode ul li span{
  color: #c9cdd4;
}

</style>